<template>
  <!-- ロゴは非表示 -->
  <NavigationLayout
    :navigationTitle="``"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div class="ly_cont" slot="contents">
      <div class="loading">
        <b-spinner variant="primary" label="Spinning" />
        <div class="loading_text">
          <!-- 支払い情報を確認しています... -->
          {{ $t('order_details__purchase_check') }}
        </div>
      </div>
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import NavigationLayout from '@/components/NavigationLayout.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import { api } from '@/api/appGatewayServerApi'
import * as models from '@/models'
import { handleUnauthorized } from '@/utils/handle_error'

@Component({
  components: {
    NavigationLayout,
    PrimaryButton,
  },
})
export default class MyPageCoinPurchaseCheck extends Mixins(
  LanguageQueryHandler
) {
  async created() {
    const purchaseId = this.$route.query.purchase_id as string
    const state = this.$route.query.state as string

    const checkStatus = async () => {
      try {
        const response = await api().streamer.currency.coin.purchase.status({
          purchaseId: purchaseId,
          providerId: models.ProviderIdTypes.PayPay,
          state: state,
        })

        let totalCoin = response.product.totalGem
        // ボーナスコインがある場合はtotalCoinに加算
        if (response.product.realityCoinBonus > 0) {
          totalCoin += response.product.realityCoinBonus
        }

        const moveToComplete = () => {
          this.$router
            .push({
              name: 'coin_purchase_complete',
              query: {
                purchaseId: purchaseId,
                purchasedCoins: totalCoin.toString(),
              },
            })
            .catch(() => {
              // Nothing to do
            })
        }

        // 完了していたら完了画面に遷移
        if (response.status.status == 'completed') {
          moveToComplete()
          return
        }

        // 決済サービスサイドでの支払い完了、Gamelibサイドのジェム付与未完了
        // 決済を完了させ、再度ステータスを確認する
        if (response.status.status == 'requires_gamelib_commit') {
          await api().streamer.currency.coin.purchase.commit({
            purchaseId: purchaseId,
            providerId: models.ProviderIdTypes.PayPay,
            params: '', // PayPayでは追加のログ情報は不要
          })
          setTimeout(checkStatus, 3000)
          return
        }

        // 基本的には完了以外の場合は決済エラーを表示してマイページに遷移
        // 'failed', 'initial', 'in_progress', 'requires_action', 'invalid', ... others
        alert(this.$t('order_details__purchase_check__failed'))
        this.$router.push({ path: '/mypage' }).catch(() => {})
        return
      } catch (e) {
        if (!(await handleUnauthorized(e))) {
          // その他のリクエストエラー、セッション切れ
          this.$router.push({ path: '/mypage' }).catch(() => {})
        }
        return
      }
    }

    setTimeout(checkStatus, 3000)
  }
}
</script>

<style scoped>
.ly_cont {
  position: relative;
  height: auto;
  min-height: 100%;
  padding: 0px;
  gap: 14px;

  @media (min-width: 327px) {
    width: 327px;
    margin: 0 auto;
  }
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 14px;

  position: absolute;
  width: 327px;
  height: 82px;
  left: calc(50% - 327px / 2);
  top: calc(50% - 82px / 2);
}

.loading_text {
  width: 327px;
  height: 20px;

  font-family: 'Noto Sans CJK JP';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  color: #737373;
}
</style>
